const onlyNumbers = (value: string | number | undefined): string | null => {
  if (!value) return null;

  value = value.toString();
  return value.replace(/\D/gm, "");
};

// expected format ex: +55 (11) 94545-4545
const removeDDI = (value: string): string => {
  const [ddi, ddd, number] = value.split(" ");
  return `${ddd} ${number}`;
};

export { onlyNumbers, removeDDI };
